// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3ZeXM","label":"Labeled_label__J2G5x","divider":"Labeled_divider__bHMnc"};